import { FC, memo } from 'react'
import { Flex, SimpleGrid, Text } from '@chakra-ui/react'

import CalendarNumber from './components/CalendarNumber'
import EndCalendarHeader from './components/Header'
import { useCalendarFilters } from '../../../../contexts/CalendarFiltersManager/Provider'
import CalendarCard from '../../../../localComponents/CalendarCard'

type Props = {
  year: number
  daysInCalendar: any[]
  daysOfTheWeek: string[]
  stringMonth: string
  goNextMonth: () => void
}

const EndCalendar: FC<Props> = ({ year, daysOfTheWeek, stringMonth, goNextMonth, daysInCalendar }) => {
  const { finalDate, setFinalDate, startDate, setStartDate } = useCalendarFilters()

  return (
    <CalendarCard>
      <EndCalendarHeader year={year} stringMonth={stringMonth} onClick={goNextMonth} />

      <SimpleGrid columns={7} gap={2}>
        {daysOfTheWeek.map((week, index) => (
          <Flex justify={{ base: 'flex-start', md: 'center' }} pt={4} key={index}>
            <Text fontSize="xs">{week}</Text>
          </Flex>
        ))}

        {daysInCalendar.map((dayInfo) => {
          return (
            <CalendarNumber
              {...dayInfo}
              key={dayInfo.stringDate}
              startDate={startDate}
              setStartDate={setStartDate}
              finalDate={finalDate}
              setFinalDate={setFinalDate}
            />
          )
        })}
      </SimpleGrid>
    </CalendarCard>
  )
}

export default memo(EndCalendar)
